module.exports = __webpack_public_path__ + "img/gear.c2e9989b.svg";